<template>
  <div class="home-page">
    <Teleport to="head">
      <!-- useHead() is less performant -->
      <link
        v-if="imageSlides?.length"
        rel="preload"
        as="image"
        :href="imageSlides[0].image"
        :alt="imageSlides[0].name"
      />
    </Teleport>
    <ConfirmationDialog
      :showModal="showConfirmDialog"
      :message="message"
      button2Text="إلغاء"
      :message2="message2"
      @close="closeDialog()"
      @submit="closeDialog()"
    >
    </ConfirmationDialog>
    <div class="header-area bg-white">


      <div class="slider-area" :class="{ 'endowments-mode': isEndowmentMode }" dir="ltr" data-cy="slider" v-if="!this.isSehattyHome">
        <div class="bd-example">
          <div class="carousel slide" data-ride="carousel">
            <div class="carousel-inner" ref="slider">
              <div
                class="image-slider position-relative"
                v-if="imageSlides?.length"
              >
                <Carousel
                  :value="imageSlides"
                  :numVisible="1"
                  :numScroll="1"
                  :circular="true"
                  class="custom-carousel"
                  :autoplayInterval="setInterval"
                  :showNavigators="false"
                  :showIndicators="false"
                >
                  <template #item="slotProps">
                    <div
                      class="d-flex position-relative slide-item justify-content-center justify-content-sm-end align-items-center px-3 pt-0 pt-sm-0 banner-content-wrapper">
                      <img v-if="imageSlides[0].image === slotProps.data?.image" fetchpriority="high"
                        :src="slotProps.data?.image" :alt="slotProps.data?.name"
                        class="position-absolute object-fit-cover w-100 h-100 h-100 start-0 end-0" />
                      <img v-else fetchpriority="low" loading="lazy" :src="slotProps.data?.image"
                        :alt="slotProps.data?.name"
                        class="position-absolute object-fit-cover w-100 h-100 start-0 end-0" />
                      
                      <!-- Gradient Overlay -->
                      <div class="carousel-overlay position-absolute w-100 h-100 start-0 top-0"
                           :class="{ 'awqaf-gradient': $route.query.mode === 'endowments' }"></div>

                      <div
                        class="summary d-flex flex-column align-items-center align-items-sm-end mt-0 position-relative" style="z-index: 2; touch-action: pan-y;"
                        @touchmove.stop
                      >
                        <div class="summary__text text-white mb-2 fs-1 fw-bold">
                          {{ slotProps.data?.title }}
                        </div>
                        <div class="summary__description text-white mb-4 fs-4 text-center text-sm-end" style="max-width: 600px;">
                          {{ slotProps.data?.description }}
                        </div>
                        <a :href="slotProps.data?.url_link" v-if="!isEndowmentMode">
                          <Button
                            class="p-button-primary w-200 fw-light"
                            label="تبرع الآن"
                          />
                        </a>
                      </div>
                    </div>
                  </template>
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section class="section-cases-navigation position-relative" v-if="!this.isSehattyHome">
        <CasesNavigation
          @item-clicked="handleGlobalModeChange"
          @toggle-filters="toggleFilters"
          :navigation-items="this.currentNavigationItems"
          :filters-opened="this.filtersOpened"
          :hide-settings="isEndowmentMode"
        />
        <FilterCasesForm
          v-if="this.filtersOpened"
          :specialization-options="this.specializationOptions"
          :region-options="this.regionOptions"
          @submit="filterCases"
        />
      </section>
      <div :class="['cases-area', { 'sehatty': this.isSehattyHome }]">
        <div
          class="cases-area-all"
          :class="{
            'cases-area-all--additional-section':
              this.selectedCondition === 'campaigns',
          }"
        >
          <BaseSpinner
            v-if="this.loading"
            :size="4"

          />
          <HospitalsPlaceholder
            v-else-if="this.selectedCondition === 'hospitals' && !this.loading"
            class="hospitals-placeholder-wrapper"
          />
          <template v-else-if="this.selectedCondition && !this.loading">
            <CardBoard
              :type="this.endowmentCategories?.some(category => category.name === this.selectedCondition) ? 'endowment-products' : this.selectedCondition"
              :items="this.selectedItems"
              :show-more-items="this.showMoreItems && !this.endowmentCategories?.some(category => category.name === this.selectedCondition)"
              @reportCampaign="reportCampaign"
              :link-button="displayShowMoreButton && !this.endowmentCategories?.some(category => category.name === this.selectedCondition)"
              :items-filtered="casesFiltered"
              @fetch-more-items="fetchMoreItems"
              :total-items-count="this.totalItemsCount"
            />
            <div class="mt-4" v-if="this.endowmentCategories?.some(category => category.name === this.selectedCondition) && totalItemsCount > 0">
               <Paginator :rows="9" :totalRecords="totalItemsCount" :first="(awqafPage - 1) * 9" @page="onAwqafPageChange($event)"></Paginator>
            </div>
          </template>
          <CardBoard
            v-else
            :items="this.filteredCases"
            @reportCampaign="reportCampaign"
            :link-button="displayShowMoreButton"
            :items-filtered="casesFiltered"
            @fetch-more-items="fetchMoreItems"
            :total-items-count="this.totalItemsCount"
          />
        </div>
      </div>

      <section class="bg-white" v-if="!this.isSehattyHome">
        <div :class="isEndowmentMode ? 'endowments-container' : 'container cases-section-width'">
          <!-- Top Stats Section -->
          <div class="row" :class="{ 'mb-5': !isEndowmentMode }">
             <div class="col-12">
                <MostafeedSection
                  v-if="pageModel && !isEndowmentMode"
                  :data="pageModel"
                  :is-endowments-mode="isEndowmentMode"
                  class="w-100"

                ></MostafeedSection>
             </div>
          </div>

          <!-- Info Cards Row -->
          <div class="row justify-content-center" v-if="!isEndowmentMode">
             <!-- Ambassador Card -->
             <div class="col-md-4 mb-3">
                <router-link
                  to="/ambassador/top"
                  class="tile tile--hover d-flex text-decoration-none w-100"
                  style="height: 200px;"
                  data-cy="top-ambassador-link"
                >
                  <VLazyImage
                    v-if="images.shefaaAmbassador"
                    class="tile__picture"
                    :src="images.shefaaAmbassador"
                    alt="Shefaa Ambassadors"
                  />
                  <VLazyImage
                    v-else
                    class="tile__picture"
                    :src="`${staticUrl}/static/images/ambassadors.png`"
                    alt="Shefaa Ambassadors"
                  />
                  <span class="tile__text fw-bolder">سفراء شفاء</span>
                  <div class="tile__cover"></div>
                </router-link>
             </div>

             <!-- Major Donors Card -->
             <div class="col-md-4 mb-3">
                <router-link
                  to="/major-donors"
                  class="tile tile--hover d-flex text-decoration-none w-100"
                  style="height: 200px;"
                  data-cy="major-donors-link"
                >
                  <VLazyImage
                    v-if="images.majorDonors"
                    class="tile__picture"
                    :src="images.majorDonors"
                    alt="Major Donors"
                  />
                  <VLazyImage
                    v-else
                    class="tile__picture"
                    :src="`${staticUrl}/static/images/major-donors.png`"
                    alt="Major Donors"
                  />
                  <span class="tile__text fw-bolder">كبار المانحين</span>
                  <div class="tile__cover"></div>
                </router-link>
             </div>

             <!-- Health Initiatives Card -->
             <div class="col-md-4 mb-3">
                 <router-link
                  to="/health-initiatives"
                  class="tile tile--hover d-flex text-decoration-none w-100"
                  style="height: 200px;"
                  data-cy="health-initiatives-link"
                >
                  <VLazyImage
                    v-if="images.healthInitiatives"
                    class="tile__picture"
                    :src="images.healthInitiatives"
                    alt="Health Initiatives"
                  />
                  <VLazyImage
                    v-else
                    class="tile__picture"
                    :src="`${staticUrl}/static/images/health-initiatives.png`"
                    alt="Health Initiatives"
                  />
                  <span class="tile__text fw-bolder">مبادرات القطاع الصحي</span>
                  <div class="tile__cover"></div>
                </router-link>
             </div>
          </div>
        </div>
      </section>
    </div>
  </div>

  <div class="row" v-if="canDonate && !this.isSehattyHome" >
    <div
      @click.stop="onQuickDonationClicked"
      :class="[
        's_w_donation_header_btn btn',
        { 'only-icon': isScrolledDown, expanded: isQuickDonationOpened },
      ]"
    >
      <div
        class="donation-wrapper text-right text-white d-flex justify-content-between align-items-center"
      >
        <span class="d-block donate-text w-100 py-2 text-center"
          >تبرع سريع</span
        >
        <i class="pi pi-plus-circle mx-2 py-2 fs-4"></i>
      </div>
    </div>

    <div
      :class="[
        's_w_donation text-right width-450p pr-0 white pl-3',
        isQuickDonationOpened ? 'd-block' : 'd-none',
      ]"
    >
      <div class="w-100 mb-2">
        <div class="case-container d-flex">
          <div
            class="case text-center"
            v-for="(type, index) in types"
            :key="index"
            :class="{ selected: type.id === donationModel.selected_type }"
            @click.stop="
              disableFields = false;
              donationModel.selected_type = type.id;
              donationModel.donation_amount = null;
              selectedType = type;
              showError = false;
            "
          >
            {{ type?.name }}
          </div>
        </div>
        <div class="text-black text-center my-2">
          {{ selectedType?.description }}
        </div>
      </div>
      <div class="justify-content-center align-content-center">
        <div class="tags mt-1 mb-4">
          <div class="d-flex justify-content-evenly">
            <div class="tag"
              :class="{ 'selected-button': donationModel.donation_amount === quickDonationAmounts[0], 'p-disabled': disableFields }"
              @click="AddDonationAmount(quickDonationAmounts[0])" data-cy="ten-riyal">{{ quickDonationAmounts[0] }} 
              <div class="sar-icon me-1" />
            </div>
            <div class="tag"
              :class="{ 'selected-button': donationModel.donation_amount === quickDonationAmounts[1], 'p-disabled': disableFields }"
              @click="AddDonationAmount(quickDonationAmounts[1])">{{ quickDonationAmounts[1] }} 
              <div class="sar-icon me-1" />
            </div>
            <div class="tag"
              :class="{ 'selected-button': donationModel.donation_amount === quickDonationAmounts[2], 'p-disabled': disableFields }"
              @click="AddDonationAmount(quickDonationAmounts[2])">{{ quickDonationAmounts[2] }} 
              <div class="sar-icon me-1" />
            </div>
          </div>
        </div>
        <div class="mb-4 mx-2 custom-input-number" data-cy="donation-amount">
          <BaseInputNumber
            :label="'أدخل مبلغ التبرع'"
            v-model="donationComputedAmount"
            :disabled="disableFields"
            min="1"
            :max="1000000"
            id="donation-amount"
            :class="{ 'p-invalid': showError }"
          />
          <span v-if="showError" class="error-message">
            <span>الحد الادنى للمبلغ الذي يمكن التبرع به هو </span>
            <span>{{ this.errorAmount }}</span>
          </span>
        </div>
        <div class="mb-1 mx-2" v-if="!$store.getters.isAuthenticated">
          <BaseInputNumber
            :label="'رقم الجوال لتصلك رسالة التبرع'"
            v-model="donationModel.doner_mobile"
            :disabled="disableFields"
            :class="{
              'p-invalid':
                donationModel.doner_mobile &&
                !isValidMobileNumber(donationModel.doner_mobile),
            }"
            id="doner-mobile"
            :maxLength="10"
            :phoneNumber="true"
          />
        </div>
        <div class="mb-2 color-secondary">وسيلة الدفع</div>
        <div
          class="payment-methods d-flex align-items-center justify-content-center mb-3"
        >
          <div
            class="item"
            @click="cardType = 'credit_card'"
            :class="{ selected: cardType === 'credit_card' }"
          >
            <VLazyImage
              class="payment-radio__image payment-radio__image--visa"
             :src="`${staticUrl}/static/images/card-pay-payment.png`"
              alt=""
            />
          </div>
          <div>
            <div
              class="apple-pay item"
              @click="applePayDonation"
              :class="{
                selected: cardType === 'applepay',
                'p-disabled': disableSubmit,
              }"
            >
              <VLazyImage
                :src="`${staticUrl}/static/images/apple-pay-logo.png`"
                alt="apple-pay"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <DonationPrivacyPolicy />
          <BaseSpinner v-if="showApplepaySpinner" />
          <Button
            class="p-button p-button-rounded p-button-primary w-50 m-auto d-flex justify-content-center"
            v-if="cardType === 'credit_card'"
            @click.stop="donate"
            :disabled="disableSubmit"
          >
            <i v-if="loadingDonation" class="pi pi-spin pi-spinner ms-2"></i>
            <span class="text-center" data-cy="donate-now-btn">تبرع الآن</span>
          </Button>
          <div
            :class="['form-cont', { 'd-none': cardType !== 'applepay' }]"
            v-if="donationModel.donation_amount && isHyperpayInjected"
          >
            <form
              :action="redirectURI"
              class="paymentWidgets"
              :data-brands="'APPLEPAY'"
            ></form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ConfirmDialog appendTo="#app" :draggable="false" />
  <DonationSuccessDialog
    :showModal="showDonationSuccessModal"
    :data="successDonationData"
    :donationType="donationType"
    :heading="paymentSuccessHeading" :message="paymentSuccessMessage"
    :isEndowmentMode="isEndowmentMode"
    v-if="showDonationSuccessModal"
    @close="closeAndRedirectHome('showDonationSuccessModal')"
  ></DonationSuccessDialog>

  <DonationFailureDialog :showModal="showDonationFailureModal" :message="paymentFailureMessage"
    :heading="paymentFailureHeading"
    v-if="showDonationFailureModal" @close="closeAndRedirectHome('showDonationFailureModal')"></DonationFailureDialog>


  <DonationInProgressDialog
    :showModal="showInProgressModal"
    :data="progressDonationData"
    :status="progressStatus"
    :donationType="donationType"
    v-if="showInProgressModal"
    @close="closeAndRedirectHome('showInProgressModal')"
  />

  <EmailVerificationModal :showModal="showEmailModal" :mobile_number="mobile_number" :requestType="otpType.VERIFY_DONOR_EMAIL" @setVerifiedEmail="this.setVerifiedEmail" />
</template>

<script>
import { defineComponent } from "vue";

import MostafeedSection from "@/components/home/mostafeed.vue";
import { ToastSeverity } from "primevue/api";
import WaqfCard from "@/components/home/waqf-card";
import CampaignCard from "@/components/home/campaign-card";
import CasesNavigation from "@/components/home/CasesNavigation";
import CardBoard from "@/components/home/CardBoard";
import BaseSpinner from "@/components/layout/BaseSpinner";
import FilterCasesForm from "@/components/home/FilterCasesForm";

import HomePageService from "@/services/home-page.service";
import DonationService from "@/services/donation.service";
import JwtUtilService from "@/services/jwt.util.service";
import WalletService from "@/services/wallet.service";
import CasesService from "@/services/case-service";
import EnumService, { DONATION_TYPE, SPECIALTIES, REGIONS } from "@/services/enum.service";
import CampaignsService from "@/services/campaigns.service";
import DonationFailureDialog from "@/components/donate/DonationFailureDialog";
import DonationSuccessDialog from "@/components/donate/DonationSuccessDialog";
import DonationInProgressDialog from "@/components/donate/DonationInProgressDialog";
import DonationPrivacyPolicy from "@/components/layout/DonationPrivacyPolicy";
import hyperpayMixin from "@/mixins/hyperpayMixin";

import { getBrowserEngine } from "@/hooks/useBrowserEnvironmet";
import isValidMobileNumberMixin from "@/mixins/isValidMobileNumberMixin";
import VLazyImage from "v-lazy-image";
import ConfirmationDialog from "@/components/admin-panel/ConfirmationDialog.vue";
import { getLocalValue, setLocalValue } from "@/hooks/useLocalStorage";
import { DONATION_AMOUNTS_CONFIG } from '@/config/donationAmountsConfig';
import { OTP_TYPE } from "@/services/otp.service";
import Paginator from "primevue/paginator";
import HospitalsPlaceholder from "@/components/home/HospitalsPlaceholder";
import { extractPaymentFailureMessage } from "@/helpers/paymentStatusError";
import EmailVerificationModal from "@/components/layout/EmailVerificationModal";
import UserProfileService from "@/services/user-profile.service";

export default defineComponent({
  mixins: [isValidMobileNumberMixin, hyperpayMixin],
  name: "HomeView",
  inject: ["staticUrl"],
  components: {
    DonationFailureDialog,
    DonationSuccessDialog,
    FilterCasesForm,
    BaseSpinner,
    CardBoard,
    CasesNavigation,
    WaqfCard,
    CampaignCard,
    MostafeedSection,
    DonationPrivacyPolicy,
    VLazyImage,
    ConfirmationDialog,
    DonationInProgressDialog,
    EmailVerificationModal,
    Paginator,
    HospitalsPlaceholder
  },
  data() {
    return {
      activeTab: 'cases',
      redirectURI: "",
      pageModel: {},
      donationModel: {
        donation_amount: null,
      },
      selectedType: {},
      cardsConfig: {
        page: "home",
      },
      imageSlides: [],
      sliderPaused: false,
      interval: 3000,
      specialties: [],
      availableCases: [],
      completedCases: [],
      isQuickDonationOpened: false,
      types: [],
      checkoutId: "",
      browserName: "",
      cardType: "credit_card",
      selectedCaseType: "AVAILABLE",
      filteredCases: [],
      isScrolledDown: false,
      canDonate:
        JwtUtilService.getClientID()?.includes("doner") ||
        !this.$store.getters.isAuthenticated,
      casesNavigationItems: [
        {
          name: "cases",
          label: "الحالات",
          iconName: "patients",
        },
        // {
        //   name: 'projects',
        //   label: 'المشاريع',
        // },
        {
          name: "markItClose",
          label: "قفّلها",
          iconName: "lockit",
        },
        {
          name: "campaigns",
          label: "أنشئ حملتك",
          iconName: "campaigns",
        },
      ],
      filtersOpened: false,
      lockItHomepageCase: null,
      selectedCondition: null,
      awqafPage: 1,
      selectedItems: [],
      specializationOptions: [],
      regionOptions: [],
      loading: false,
      filterParams: {},
      casesFiltered: false,
      showMoreItems: [],
      pageNumber: 1,
      totalItemsCount: 0,
      allCasesDonationWalletId: null,
      images: {
        majorDonors: "",
        healthInitiatives: "",
        shefaaAmbassador: "",
      },
      paymentFailureMessage: "",
      paymentFailureHeading: "",
      showDonationFailureModal: false,
      resourcePath: "",
      paymentTransactionId: 0,
      isHyperpayInjected: false,
      showApplepaySpinner: false,
      showDonationSuccessModal: false,
      paymentSuccessHeading: "",
      paymentSuccessMessage: "",
      showInProgressModal: false,
      successDonationData: {},
      progressDonationData: {},
      progressStatus: 202,
      donationType: DONATION_TYPE.CASE,
      isSubmitted: false,
      disableFields: false,
      activeCases: 0,
      foundSelectors: false,
      loadingDonation: false,
      message: "حساب الجمعية موقوف",
      message2: "يرجى تحديث الترخيص لتفعيل رفع الطلبات",
      charityAccountState: getLocalValue("charity_account_state"),
      showError: false,
      integrity: "",
      isSehattyHome: this.$store.getters.isSehattyPage,
      duringPeakLoad: true,
      showEmailModal: false,
      mobile_number: null,
      otpType: OTP_TYPE,
      endowmentCategories: null,
    };
  },
  created() {
    this.quickDonationAmounts = DONATION_AMOUNTS_CONFIG.quickDonation.mostUrgent.presetAmounts;
    this.configMinimumAmount = DONATION_AMOUNTS_CONFIG.quickDonation.mostUrgent.minimumAmount;
    window.addEventListener("scroll", this.handleScroll);
  },
  watch: {
    '$route.query.tab': {
      handler(newTab) {
        if (newTab) {
          this.activeTab = newTab;
          this.scrollAndFilter(newTab);
        }
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  updated() {
    if (!this.foundSelectors) {
      this.createPauseButton();
    }
  },
  mounted() {
    
    if(!this.isSehattyHome){
      this.getHomePageDetails();
    }
    
    this.checkEmailModal();

    const baseHomeUrl = process.env.VUE_APP_FE_URL + `/home`;
    this.redirectURI = this.isEndowmentMode ? `${baseHomeUrl}?mode=endowments` : baseHomeUrl;
    if (this.$route.query.reference_id) {
      this.isAmbassador = true;
      this.referenceId = this.$route.query.reference_id;
    }

    if (this.$route.query.id && this.$route.query.resourcePath) {
      this.resourcePath = this.$route.query.resourcePath;
      this.paymentTransactionId = this.$route.query.id;

      this.checkPaymentStatus();
    } else {
      this.checkPendingPayment();
    }
  },
  computed: {
    isEndowmentMode() {
      return this.$route.query.mode === 'endowments';
    },
    currentNavigationItems() {
      if (this.isEndowmentMode) {
        return this.endowmentCategories

      }
      return this.casesNavigationItems;
    },
    displayShowMoreButton() { 
      return !this.isSehattyHome
    },
    setInterval() {
      return this.sliderPaused ? 99999999 : 4000;
    },
    disableSubmit() {
      return !!(
        !this.donationModel.donation_amount ||
        (this.donationModel.doner_mobile &&
          !this.isValidMobileNumber(this.donationModel.doner_mobile)) ||
        this.customValidation ||
        this.loadingDonation
      );
    },
    showConfirmDialog() {
      return this.charityAccountState?.suspendedAccDialogShow || false;
    },
    customValidation() {
      if (this.donationModel.selected_type === this.allCasesDonationWalletId) {
        return this.donationModel.donation_amount < this.activeCases;
      }
      else
        return this.donationModel.donation_amount < this.configMinimumAmount;
    },
    errorAmount() {
      return this.donationModel.selected_type === this.allCasesDonationWalletId ? this.activeCases : this.configMinimumAmount;
    },
    donationComputedAmount: {
      get() {
        return this.donationModel.donation_amount;
      },
      set(value) {
        this.AddDonationAmount(value);
      },
    },
  },
  watch: {
    '$store.getters.isAuthenticated': {
      handler(newVal) {
        if(newVal) {
          this.checkEmailModal();
        }
      },
      immediate: true
    }
  },
  methods: {
    loggedInDifferentUser() {
      this.$store.dispatch(STORE_ENUM.USERNAME, localStorage.getItem("username"));
      this.username = this.$store.state.authModule.username;
      this.isDonor = JwtUtilService.getClientID()?.includes("doner");
      this.items = [{
        label: "تسجيل الخروج",
        icon: "pi pi-sign-out",
        command: () => {
          this.logout();
        }
      }] 
    },
    scrollAndFilter(type) {
        this.activeTab = type;
        this.$forceUpdate();
    },
    closeDialog() {
      this.charityAccountState.suspendedAccDialogShow = false;
      setLocalValue("charity_account_state", this.charityAccountState);
    },
    checkEmailModal() {
      if(this.$store.getters.isAuthenticated && 
         this.$store.getters.isDonor && 
         !getLocalValue('useremail')) {
        this.mobile_number = getLocalValue('donor_mobile_number');
        this.showEmailModal = true;
      }
    },
    setVerifiedEmail(email) {
      let setEmailPayload = {};
      setEmailPayload.mobile_number = getLocalValue('donor_mobile_number').split("-").join("");
      setEmailPayload.email = email;
      UserProfileService.updateProfileInfo(setEmailPayload)
        .then(({ data: { result } }) => {
          setLocalValue("useremail", setEmailPayload.email);
          this.showEmailModal = false;
          this.$router.go();
          this.$toast.add({ 
            severity: ToastSeverity.SUCCESS, 
            detail: result, 
            life: 3000 
          });
        })
    },
    getHomePageDetails() {
      this.loading = true;
      const mode = this.$route.query.mode;
      HomePageService.getHomePageDetails(mode).then(({ data: { result } }) => {
        this.imageSlides = result.banner;
        this.specialties = result.specialties;
        this.completedCases = result.completed_cases;
        this.pageModel = result;
        this.images = {
          majorDonors: result.major_donors_image,
          healthInitiatives: result.health_initiatives_image,
          shefaaAmbassador: result.shefaa_ambassador_image,
        };
          if (mode === 'endowments') {
            this.endowmentCategories = result.categories?.map(category => ({
              name: category.name,
              label: category.label,
             iconActive : category.active_icon_url,
              iconInactive : category.inactive_icon_url
            }));
          }
          //add one more hardcoded
            this.endowmentCategories?.push({
                name: 'hospitals',
                label: 'مستشفيات قريباً',
                iconActive: `${this.staticUrl}/hef_waqf%2Fcategories%2Ficons%2Ffilter-hospitals-icon-active.svg`,
                iconInactive: `${this.staticUrl}/hef_waqf%2Fcategories%2Ficons%2Ffilter-hospitals-icon-non-active.svg`
            });
            if (this.isEndowmentMode) {
              this.getConditionalCases(this.endowmentCategories[0].name);
            } else {
              this.loadLockItHomepageCase().then(() => this.getTotalCasesCount());
            }
      });
      this.loading = false;
    },
    getMedicalDropDown() {
      if(this.duringPeakLoad){
        this.specializationOptions = SPECIALTIES;
        return;
      }
      CasesService.getMedicalDataDropdown().then((result) => {
        this.specializationOptions = result.data.result.case_specialty;
      });
    },
    getRegions() {
     if(this.duringPeakLoad){
      this.regionOptions = REGIONS;
      return;
     }
      EnumService.regions().then((result) => {
        this.regionOptions = result.data.result;
      });
    },
    donate() {
      this.loadingDonation = true;
      const postBody = {
        amount: this.donationModel.donation_amount,
        card_type: this.cardType,
        wallet_id: this.selectedType?.id,
        is_waqf_sehi: this.selectedType.is_waqf_wallet,
        to_wallet: this.donationModel.selected_type,
        link_of_the_donated_on_object: process.env.VUE_APP_FE_URL + "/home",
        donor_mobile_number: getLocalValue("donor_mobile_number") || this.donationModel.doner_mobile || null,
      };
      
      if (this.isEndowmentMode && this.selectedType.is_waqf_wallet) {
        postBody.platform = 'hef';
      }
      
      DonationService.getPaymentId(postBody)
        .then(
          ({
            data: {
              result: { checkout_id, integrity },
            },
          }) => {
            this.checkoutId = checkout_id;
            this.integrity = integrity;
            setLocalValue("scriptIntegrity", integrity);
            localStorage.setItem(
              "donationModel",
              JSON.stringify(this.donationModel)
            );
            localStorage.setItem(
              "wallet",
              JSON.stringify(this.donationModel.selected_type)
            );
            if (this.selectedType.is_waqf_wallet) {
              localStorage.setItem(
                "is_waqf_wallet",
                this.selectedType.is_waqf_wallet
              );
            }
            this.injectCheckoutLibrary();
          }
        )
        .catch(
          ({
            response: {
              data: { errors },
            },
          }) => {
            this.paymentFailureMessage = errors[0];
            this.showDonationFailureModal = true;
          }
        )
        .finally(() => {
          this.loadingDonation = false;
        });
    },
    applePayDonation() {
      this.isSubmitted = true;
      this.disableFields = true;

      if (!this.donationModel.donation_amount) {
        return;
      }

      this.cardType = "applepay";
      if (this.isHyperpayInjected) {
        return;
      }

      this.showApplepaySpinner = true;

      const baseHomeUrl = process.env.VUE_APP_FE_URL + "/home";
      const homeRedirectUrl = this.isEndowmentMode ? `${baseHomeUrl}?mode=endowments` : baseHomeUrl;
      
      const postBody = {
        card_type: this.cardType,
        amount: this.donationModel.donation_amount,
        is_waqf_sehi: this.selectedType.is_waqf_wallet,
        wallet_id: this.selectedType?.id,
        to_wallet: this.donationModel.selected_type,
        link_of_the_donated_on_object: homeRedirectUrl,
        donor_mobile_number: getLocalValue("donor_mobile_number") || this.donationModel.doner_mobile || null,
      };
      
      if (this.isEndowmentMode && this.selectedType.is_waqf_wallet) {
        postBody.platform = 'hef';
      }
      
      DonationService.getPaymentId(postBody)
        .then(
          ({
            data: {
              result: { checkout_id, integrity },
            },
          }) => {
            this.checkoutId = checkout_id;
            this.integrity = integrity;
            setLocalValue("scriptIntegrity", integrity);
            localStorage.setItem(
              "donationModel",
              JSON.stringify(this.donationModel)
            );
            localStorage.setItem(
              "wallet",
              JSON.stringify(this.donationModel.selected_type)
            );
            this.injectCheckoutLibrary();
          }
        )
        .catch(
          ({
            response: {
              data: { errors },
            },
          }) => {
            this.paymentFailureMessage = errors[0];
            this.showDonationFailureModal = true;
            this.showApplepaySpinner = false;
          }
        );
    },
    injectCheckoutLibrary() {
      let paymentLibraryScript = document.createElement("script");
      paymentLibraryScript.setAttribute(
        "src",
        `${process.env.VUE_APP_HYPERPAY_URL}/v1/paymentWidgets.js?checkoutId=${this.checkoutId}`
      );
      paymentLibraryScript.setAttribute(
        "integrity",
        getLocalValue("scriptIntegrity")
      );
      paymentLibraryScript.setAttribute("crossorigin", "anonymous");
      if (window.__nonce) {
        paymentLibraryScript.setAttribute("nonce-" + window.__nonce, "");
      }
      document.head.appendChild(paymentLibraryScript);

      this.isHyperpayInjected = true;
      setTimeout(() => {
        this.showApplepaySpinner = false;
      }, 300);
      if (this.cardType === "applepay") {
        return;
      }
      this.$router.push(
        `/checkout?card_type=${this.cardType}&donation_amount=${this.donationModel.donation_amount}`
      );
    },
    getCases() {
      WalletService.getCases(0, true).then(({ data: { result } }) => {
        this.allCasesDonationWalletId = result?.[0]['all-cases-wallet'];
        const allCasesWalletObject = result.find(
          (item) => item.id === this.allCasesDonationWalletId
        );
        this.activeCases = allCasesWalletObject?.minimum_amount;
        this.types = result.slice(1);
        this.donationModel.selected_type = this.types?.length
          ? this.types[0]?.id
          : {};
        this.selectedType = this.types?.length ? this.types[0] : {};
      });
    },
    handleGlobalModeChange(mode) {
      console.log('handleGlobalModeChange triggered via EVENT/MOUNT with mode:', mode);
      const tabToFetch = mode || 'cases';
      this.getConditionalCases(tabToFetch);
    },
    async loadLockItHomepageCase() {
      if (this.isEndowmentMode || this.isSehattyHome) return;
      await HomePageService.get
        .lockItHomepageCase()
        .then(({ data }) => {
          this.lockItHomepageCase = data?.result || null;
        })
        .catch(() => {
          this.lockItHomepageCase = null;
        });
    },
    caseListWithLockIt(cases) {
      if (!this.lockItHomepageCase || this.selectedCondition !== "cases") {
        return cases;
      }
      return [
        this.lockItHomepageCase,
        ...cases.filter((item) => item.id !== this.lockItHomepageCase.id),
      ];
    },
    withoutLockItCase(cases) {
      if (!this.lockItHomepageCase) return cases;
      return cases.filter((item) => item.id !== this.lockItHomepageCase.id);
    },
    async getConditionalCases(name) {
      this.casesFiltered = false;
      this.loading = true;
      this.pageNumber = 1;
      this.selectedCondition = name;
      if (name === 'endowments') {
        this.awqafPage = 1;
      }
      if (this.selectedCondition !== "cases") {
        this.filtersOpened = false;
      }
      
      if (this.selectedCondition === 'hospitals') {
         this.selectedItems = [];
         this.totalItemsCount = 0;
         this.loading = false;
         return;
      }

      if ( this.endowmentCategories?.some(category => category.name === this.selectedCondition)) {
         await CasesService.getAwqafProducts({ page: this.awqafPage, page_size: 9 , category: this.selectedCondition }).then((response) => {
             const result = response.data;
             this.selectedItems = result.results || [];
             this.totalItemsCount = result.total_objects || 0;
             this.showMoreItems = false;
         });
      } else {
          await HomePageService.get[this.selectedCondition]().then((response) => {
            if (this.selectedCondition === "campaigns") {
              this.selectedItems = response.data.result ? response.data.result : [];
              this.totalItemsCount = response.data.result.length;
            } else {
              this.selectedItems = this.caseListWithLockIt(
                response.data.result.results ? response.data.result.results : []
              );
              this.totalItemsCount = response.data.result.total_objects;
            }
          });
      }

      this.loading = false;
    },
    reportCampaign(id) {
      this.$confirm.require({
        message: `هل أنت متأكد من الإبلاغ عن الحملة؟`,
        acceptLabel: "نعم",
        rejectLabel: "لا",
        accept: () => {
          CampaignsService.reportCampaign(id).then(({ data }) => {
            this.$toast.add({
              severity: ToastSeverity.SUCCESS,
              detail: "تم الإبلاغ عن الحملة بنجاح",
              life: 3000,
            });
            this.getConditionalCases("campaigns");
          });
        },
        reject: () => {
          this.$confirm.close();
        },
      });
    },
    toggleFilters() {
      this.filtersOpened = !this.filtersOpened;
      if(this.filtersOpened){
        if (!this.specializationOptions.length) {
          this.getMedicalDropDown();
        }
        if (!this.regionOptions.length) {
          this.getRegions();
        }
      }
    },
    async filterCases(filterParams) {
      this.loading = true;
      this.filtersOpened = false;
      this.filterParams = filterParams;
      this.pageNumber = 1;
      await HomePageService.get
        .FilteredCases(filterParams, this.pageNumber)
        .then((response) => {
          this.selectedItems = response.data?.result.results
            ? response.data?.result.results
            : [];
          this.totalItemsCount = response.data?.result.total_objects;
        })
        .catch((err) => {
          this.$toast.add({
            severity: ToastSeverity.INFO,
            detail: "لا توجد مثل هذه الحالة",
            life: 3000,
          });
          this.selectedItems = [];
        });
      this.loading = false;
      this.casesFiltered = true;
    },
    async fetchMoreItems() {
      this.pageNumber++;
      await HomePageService.get
        .FilteredCases(this.filterParams, this.pageNumber)
        .then((response) => {
          this.showMoreItems = this.withoutLockItCase(
            response.data?.result.results ? response.data?.result.results : []
          );
          this.totalItemsCount = response.data?.result.total_objects;
        })
        .catch((err) => {
          this.$toast.add({
            severity: ToastSeverity.INFO,
            detail: "لا توجد مثل هذه الحالة",
            life: 3000,
          });
          this.selectedItems = [];
        });
    },
    onQuickDonationClicked() {
      this.isQuickDonationOpened = !this.isQuickDonationOpened;
      if (this.isQuickDonationOpened) {
        this.getCases();
        this.browserName = getBrowserEngine();
      }
    },
    handleScroll() {
      this.isScrolledDown = document.documentElement.scrollTop > 0;
    },
    toggleSliderAutoplay() {
      this.sliderPaused = !this.sliderPaused;
      this.changePauseButtonIcon();
    },
    changePauseButtonIcon() {
      const pauseBtnIcon = document.querySelector("#pause-button-icon");
      pauseBtnIcon.classList.contains("pi-pause")
        ? pauseBtnIcon.classList.remove("pi-pause")
        : pauseBtnIcon.classList.add("pi-pause");
      pauseBtnIcon.classList.contains("pi-play")
        ? pauseBtnIcon.classList.remove("pi-play")
        : pauseBtnIcon.classList.add("pi-play");
    },
    createPauseButton() {
      let sliderNav = this.$refs?.slider?.querySelector(
        ".p-carousel-indicators"
      );
      if (!sliderNav) {
        this.foundSelectors = false;
        return;
      }
      let sliderNavItem = this.$refs.slider.querySelector(
        ".p-carousel-indicator"
      );
      if (!sliderNavItem) {
        this.foundSelectors = false;
        return;
      }
      this.foundSelectors = true;
      let pauseLi = document.createElement("li");
      let pauseBtn = document.createElement("button");
      let pauseIcon = document.createElement("i");
      sliderNav.classList.add("align-items-center");
      pauseBtn.classList.add(
        "p-button",
        "p-button-rounded",
        "d-flex",
        "justify-content-center"
      );
      pauseIcon.id = "pause-button-icon";
      pauseBtn.setAttribute("aria-label", "Play/Pause Slider");
      pauseIcon.classList.add("pi", "pi-pause");

      pauseBtn.style.backgroundColor = "rgba(255,255,255, 0.4)";
      pauseBtn.style.borderColor = "rgba(255,255,255, 0.4)";
      pauseBtn.style.width = "44px";
      pauseBtn.style.height = "25px";
      pauseBtn.style.marginRight = "15px";
      pauseBtn.style.marginBottom = "5px";

      pauseIcon.style.color = "#5581C4";
      pauseIcon.style.padding = "2px";
      pauseIcon.style.border = "2px solid #5581C4";
      pauseIcon.style.borderRadius = "50%";
      pauseIcon.style.fontSize = "10px";

      pauseLi.append(pauseBtn);
      pauseBtn.append(pauseIcon);
      pauseBtn.addEventListener("click", () => {
        this.toggleSliderAutoplay();
      });
      sliderNav.insertBefore(pauseLi, sliderNavItem);
    },
    onAwqafPageChange(event) {
      this.awqafPage = event.page + 1;
      this.loading = true;
      
      const casesNavigationSection = document.querySelector('.section-cases-navigation');
      if (casesNavigationSection) {
        const offset = 100;
        const elementPosition = casesNavigationSection.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
      
      CasesService.getAwqafProducts({ page: this.awqafPage, page_size: 9 }).then((response) => {
             const result = response.data;
             this.selectedItems = result.results || [];
             this.totalItemsCount = result.total_objects || 0;
             this.loading = false;
         });
    },

    getTotalCasesCount() {
      this.loading = true;
      HomePageService.get
        .cases(this.isSehattyHome)
        .then(({ data: { result } }) => {
          this.$store.state.totalCases = result.total_objects;
          if (!this.isEndowmentMode) {
             this.selectedCondition = this.currentNavigationItems[0].name;
             this.selectedItems = this.isSehattyHome? result?.results.splice(0, 6) || []: this.caseListWithLockIt(result?.results || []);
             this.totalItemsCount = result.total_objects;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setDonationSuccessData (data) {
        if (!data) return;
        this.successDonationData = data?.donation_success_data;
        this.paymentSuccessMessage = data?.message;
        this.paymentSuccessHeading = data?.heading;
        this.donationType = data?.donation_success_data?.type;
        this.showDonationSuccessModal = true;
     },
    checkPaymentStatus() {
      DonationService.getPaymentStatusWithRetry(
        this.paymentTransactionId,
        this.resourcePath
      )
        .then(({
          data
        }) => {
          if ((data.status === 202 || data.status===400) && data.result) {
            this.progressDonationData = data.result;
            this.donationType = data.result?.donation_info?.type;
            this.showInProgressModal = true;
            this.progressStatus = data.status;
          } 
          else if(data.status===200 && data.donation_success_data) {
          const successData = {
          donation_success_data: data.donation_success_data,
          message: data.message,
          heading: data.heading
        };
        this.setDonationSuccessData(successData);

          }
        })
        .catch(
           (error) => {
            this.paymentFailureMessage = extractPaymentFailureMessage(error);
            this.paymentFailureHeading = error?.response?.data?.heading;
          this.showDonationFailureModal = true;
          }
        )
        .finally(() => {
          localStorage.removeItem("donationModel");
          localStorage.removeItem("wallet");
        });
    },
    checkPendingPayment() {
      const pending = DonationService.getPendingPaymentCheck();
      if (!pending) return;

      DonationService.getPaymentStatusWithRetry(
        pending.checkoutID,
        pending.resourcePath
      )
        .then(({ data }) => {
          data?.result?.isNetworkError || DonationService.clearPendingPaymentCheck();
          if ((data.status === 202 || data.status === 400) && data.result) {
            this.progressDonationData = data.result;
            this.donationType = data.result?.donation_info?.type;
            this.showInProgressModal = true;
            this.progressStatus = data.status;
          } else if (data.status === 200 && data.donation_success_data) {
            const successData = {
              donation_success_data: data.donation_success_data,
              message: data.message,
              heading: data.heading,
            };
            this.setDonationSuccessData(successData);
          }
        })
        .catch(() => {
          // Still no network — keep pending data for next visit
        });
    },
    AddDonationAmount(amount) {
      this.donationModel.donation_amount = amount;
      if (this.customValidation) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    closeAndRedirectHome(modalFlag) {
      this[modalFlag] = false;
      this.$router.push('/home');
    },
  },
});
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "@/styles/components/donate";
@import "@/styles/components/button";
@import "@/styles/components/tile";
@import "@/styles/layout/tile-grid";
@import "@/styles/abstracts/mixins";
@import "@/styles/components/riyal-logo";



@media (max-width: 768px) {
  :deep(.slide-item img) {
  width: auto !important;
  }
}

.home-page {
  .image-slider {
    &__pause {
      position: absolute;
      bottom: 0;
      left: 100px;
    }
  }

  .banner-content-wrapper {
    padding-right: 0; 
    
    @media (min-width: 576px) {
       padding-right: 10% !important;
    }
  }

  .halat {
    padding: 18px;
    cursor: pointer;
    border-radius: 11px;
    max-width: 15%;
    margin: 1px;

    &:hover {
      background: #009688;
    }
  }

  .halat-active {
    background: #009688;
  }

  .blue-green {
    color: #2ea9a2;
  }

  .social-icons ul li a i {
    font-size: 20px;
    color: #36beb6;
  }

  .grayscale {
    filter: grayscale(1);
    -webkit-filter: grayscale(1);
  }

  .about-area {
    position: relative;
    padding-bottom: 40px;
    background: $color-white url(#{$static-url}/static/images/polygon-grey.png) no-repeat -185px;
    background-size: contain;
  }

  .halat {
    .about-icon {
      img {
        width: 54px;
        height: 54px;
      }
    }

    &:hover {
      .about-title {
        color: $color-white;
      }
    }
  }

  .about-content-dot {
    display: block;
    width: 66px;
    margin: 63px auto 2px auto;
  }

  .btn-show-all-cases {
    background-color: #00b7ae;
    color: $color-white;
    border-radius: 50px;
    height: 70px;
    font-size: 16px;
    box-shadow: 0 14px 20px -2px rgba(0, 183, 174, 0.48);
    -webkit-box-shadow: 0 14px 20px -2px rgba(0, 183, 174, 0.48);
    -moz-box-shadow: 0 14px 20px -2px rgba(0, 183, 174, 0.48);
    text-decoration: none;

    &:hover {
      color: $color-white;
    }
  }
}

.dir-rtl {
  direction: rtl;
}

::v-deep(.slide-item) {
  width: 100%;
  height: 550px;
  position: relative;
  background-repeat: no-repeat !important;
  background-size: cover !important;

  @include respond(xl) {
    height: 400px;
  }
}

.welcome {
  display: block;
  width: 80%;
  background-color: #12b3ab;
  padding: 40px 30px 30px;
  position: absolute;
  bottom: 0;
  right: 10%;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;

  p {
    text-align: right;
    font-size: 22px;
    color: $color-white;
    width: 74%;
  }

  .welcome-more {
    display: block;
    font-size: 17px;
    color: #575757;
    text-align: center;
    width: 192px;
    padding: 16px 20px;
    margin: -20px 1px 1px 20px;
    border-radius: 34px;
    background-color: #f7f7f7;
    background-image: linear-gradient(#d1d1d1, #f7f7f7);
  }
}

.s_w_donation_header_btn {
  position: fixed;
  right: -1px;
  top: 180px;
  z-index: 101;
  width: 130px;
  text-align: right;
  color: $color-white;
  padding: 0;
  vertical-align: middle;
  margin-top: -1px;
  transition: all 0.5s;

  .donation-wrapper {
    border-radius: $border-radius-default 0 0 $border-radius-default;
    background-color: $color-complementary;
    box-shadow: $box-shadow-tile;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: $color-complementary-hover;
    }

    .donate-text {
      color: $color-primary;
      background-color: $color-white;
    }

    i.pi {
      transition: transform 0.2s ease-in-out;
    }
  }

  img {
    width: 24px;
    height: 24px;
  }

  &.only-icon {
    transform: translateX(88px);
  }

  &.expanded {
    transform: translateX(0);

    i.pi {
      transform: rotate(45deg);
    }
  }
}

.s_w_donation {
  position: fixed;
  right: 0;
  top: 235px;
  z-index: 100;
  -webkit-box-shadow: -12px 13px 5px -6px rgb(114 115 114 / 9%);
  -moz-box-shadow: -12px 13px 5px -6px rgba(114, 115, 114, 0.09);
  background: $color-white 0 0 no-repeat padding-box;
  box-shadow: 0 2px 10px #5582c51a;
  opacity: 0.98;
  border-radius: 10px;

  .case-container {
    border-bottom: 1px solid $color-secondary;

    .case {
      padding: 10px;
      flex: 1;
      cursor: pointer;

      &.selected {
        color: $color-primary;
        border-bottom: 2px solid $color-primary;
        background-color: #e2f3f4;
      }

      &:not(:last-child) {
        border-left: 1px solid $color-secondary;
      }

      &:first-child {
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-top-left-radius: 8px;
      }
    }
  }
}

.s_w_donation_p {
  font-size: 15px;
  font-weight: bolder;
  letter-spacing: 0;
  color: #aeb0b0;
  opacity: 1;
}

.card_icons input {
  display: none;
}

.card_icons label {
  cursor: pointer;
}

.s_w_pay_radio:checked ~ label img {
  border: 2px solid $color-primary;
  border-radius: 24px;
}

.payment_brand_logo {
  width: 100%;
  background: $color-white 0 0 no-repeat padding-box;
}

.s_w_donation_btn {
  background: $color-primary;
  border-radius: 25px;
  text-align: center;
  color: $color-white !important;

  &:hover {
    background: darken($color-primary, 10%) !important;
  }

  img {
    width: 40px;
  }
}

.tags {
  .tag {
    margin: 0 0.5rem;
    padding: 5px 0 9px;
    text-align: center;
    color: $color-primary;
    border: 1px solid $color-primary;
    border-radius: 8px;
    cursor: pointer;
    flex: 1;

    &:hover {
      opacity: 0.7;
    }
  }
}

.payment-methods {
  .item {
    height: 50px;
    min-width: 120px;
    padding: 0 0.5rem;
    margin: 0 5px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &.selected img {
      border-color: $color-primary-border;
    }
  }

  .apple-pay {
    border: 1px solid $color-border-input;

    &.selected {
      border-color: $color-primary-border;
    }

    img {
      width: 50px;
      height: 30px;
    }
  }
}

.color-primary {
  color: $color-primary;
}

.width-20 {
  width: 20%;
}

.width-10 {
  width: 10%;
}

.width-180p {
  width: 180px;
}

.width-450p {
  width: 450px;
}

.cases-area {
  background: $color-primary-background url(#{$static-url}/static/images/polygon.png) no-repeat right;
  &.sehatty {
    background: $color-background-sehatty;
  }
  p {
    margin-bottom: 0;
  }

  .cases-area-all {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding-top: 50px;
    margin: 0 150px;
    min-height: 500px;
    padding-bottom: 35px;
    background-size: 30%;

    &--additional-section {
      padding-top: 50px;
    }
  }

  .all-cases-btn {
    display: block;
    width: 75%;
    color: $color-white;
    background-size: 100%;
    text-align: center;
    font-size: 32px;
    font-family: "DINNextLTW23-Regular", serif;
    padding: 32px 0 95px 0;
    margin: 50px auto 10px;

    &:hover {
      color: $color-text-darker;
    }
  }

  .btn-shadow {
    box-shadow: 0 0 3px 9px $color-shadow-light;
    -webkit-box-shadow: 0 0 3px 9px $color-shadow-light;
    -moz-box-shadow: 0 0 3px 9px $color-shadow-light;
  }

  .btn-unselected {
    color: $color-primary-variant;
    background-color: $color-bg-light-gray;
    box-shadow: 0 3px 10px rgb(0 0 0 / 17%);
  }

  .btn-selected {
    color: $color-white;
    background: $color-primary-variant;
    box-shadow: 0 3px 10px rgb(0 0 0 / 17%);

    &:hover {
      color: $color-white;
      background: $color-primary-variant;
    }
  }

  .available {
    border-radius: 0 20px 20px 0;
  }

  .completed {
    border-radius: 20px 0 0 20px;
  }

  a {
    color: $color-white;
    text-decoration: none;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }

  ::v-deep(.p-paginator) {
    direction: rtl;
    background-color: transparent !important;
    .p-paginator-first,
    .p-paginator-prev,
    .p-paginator-next,
    .p-paginator-last {
      transform: rotate(180deg);
    }
    .p-paginator-pages .p-paginator-page.p-highlight {
      background-color: $color-awqaaf-paginator-bg-selected !important;
      color: $color-awqaaf-paginator-text-selected !important;
    }
    .p-paginator-element:focus {
      box-shadow: none !important;
    }
    .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
      background-color: $color-bg-light-gray !important;
    }
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }

  p {
    margin-bottom: 0;
  }
}

.pointer {
  cursor: pointer;
}

.error-message {
  font-size: 14px;
  color: $color-invalid-label;
}

:deep(.p-float-label label) {
  left: 0 !important;
  right: 0.75rem;
  font-size: 14px !important;
}

::v-deep(.p-carousel-indicators) {
  position: absolute;
  bottom: 0;
  margin: auto;
  width: 100%;
}

::v-deep(.p-carousel .p-carousel-indicators .p-carousel-indicator button) {
  width: 3rem !important;
  height: 0.3rem !important;
  border-radius: 8px;
}

::v-deep(
    .p-carousel .p-carousel-indicators .p-carousel-indicator.p-highlight button
  ) {
  background-color: $color-complementary;
}

.p-button-outlined {
  width: 150px;
  border-radius: 20px;

  a {
    color: #14b8a6;
  }
}

.summary {
  z-index: 100;
  margin-top: 120px;
  text-shadow: rgba(black, 0.2) 1px 0 10px;

  &__text {
    margin-bottom: 15px;
  }

  .p-button {
    a {
      color: $color-white;
      text-decoration: none;
    }
  }
}

.w-200 {
  width: 200px;
}

.w-65 {
  width: 65%;
}

.w-35 {
  width: 35%;
}

.p-button {
  height: 40px;
}

::v-deep(.s_w_donation .p-inputnumber-input),
::v-deep(.s_w_donation .p-inputtext) {
  height: 40px !important;
}

.payment-radio {
  width: 80px;
  height: 42px;
  margin: 0 7px;
  border: 1px solid $color-secondary;
  border-radius: $border-radius-default;
  cursor: pointer;
  overflow: hidden;

  ::v-deep(.p-radiobutton) {
    opacity: 0;
    position: absolute;
  }

  &__image {
    height: 50px !important;
    object-fit: cover;
    object-position: center;
    padding: 0 0.5rem;
    margin: 0 5px;
    border: 1px solid #ced4da;
    border-radius: 8px;

    &--mada {
      height: 60px;
    }

    &--apple {
      height: 30px;
    }
  }

  &--checked {
    border-color: $color-primary;
  }
}

@include respond("xl") {
  .s_w_donation_header_btn {
    top: 180px;

    &.only-icon {
      transform: translateX(91px);
    }
  }

  .s_w_donation {
    top: 225px;
  }

  .cases-area {
    .cases-area-all {
      padding-top: 100px;
      margin: 0 75px;

      &--additional-section {
        padding-top: 50px;
      }
    }
  }
}

@include respond("lg") {
  .cases-area {
    .cases-area-all {
      padding-top: 70px;
      margin: 0 50px;

      &--additional-section {
        padding-top: 30px;
      }
    }
  }
}

@include respond("md") {
  .s_w_donation_header_btn {
    top: 150px;
  }

  .s_w_donation {
    top: 195px;
  }

  .cases-area {
    .cases-area-all {
      padding-top: 50px;

      &--additional-section {
        padding-top: 30px;
      }
    }
  }
}

@include respond("sm") {
  .s_w_donation_header_btn {
    top: 140px;
  }

  .s_w_donation {
    top: 185px;
  }

  .cases-area {
    .cases-area-all {
      margin: 0 30px;
    }
  }
}

.form-cont {
  width: 100%;
}

::v-deep(.slide-item) {
  width: 100%;
  height: 440px;
  position: relative;
  background-repeat: no-repeat !important;
  background-size: cover !important;

  @include respond(xl) {
    height: 320px;
  }
}

.slider-area {
  height: 440px;

  &.endowments-mode {
    height: 363px;

    ::v-deep(.slide-item) {
      height: 363px;

      @include respond(xl) {
        height: 264px;
      }
    }
  }

  @include respond(xl) {
    height: 320px;

    &.endowments-mode {
      height: 264px;
    }
  }
}

.new-tabs-section {
  margin-top: -10px !important;
  position: relative;
  z-index: 1; 
  .tab-item {
    height: 100px;
    font-size: 24px;
    transition: color 0.2s ease, background-color 0.2s ease;
    background-color: $color-tab-awqaf;
    cursor: pointer;
    
    .tab-text {
      color: $color-font-dark;
    }
    
    &.tab-cases {
       &.active {
          background: linear-gradient(90deg, $color-tab-cases-end 0%, $color-tab-cases-start 100%) !important;
          .tab-text {
            color: $color-white;
          }
       }
    }
    
    &.tab-awqaf {
       &.active {
          background: linear-gradient(90deg, $color-tab-cases-start 0%, $color-tab-awqaf-active-end 100%) !important;
          .tab-text {
             color: $color-white;
          }
       }
    }

    &:not(.active):hover {
      background-color: $color-tab-hover; 
    }

    .tab-icon {
      width: 60px;
      height: 60px;
    }

    .inner-tab-content {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 60%;

      @include respond("md") {
        width: 80%;
      }
      @include respond("sm") {
        width: 90%;
      }
    }
  }

  @include respond("xl") {
    margin-top: -25px !important;
  }

  @include respond("sm") {
    .tab-item {
      height: 80px;
      font-size: 18px;
       .tab-icon {
          width: 40px;
          height: 40px;
       }
    }
  }
}

.carousel-overlay {
  background: linear-gradient(to right, rgba($color-primary, 0.3), rgba($color-primary, 0.5), rgba($color-overlay-dark, 0.7));
  z-index: 1;
  pointer-events: none;
  transition: background 0.3s ease;
}

.awqaf-gradient {
  background: linear-gradient(to right, rgba($color-awqaf-light, 0.3), rgba($color-awqaf-mid, 0.5), rgba($color-awqaf-dark, 0.7)) !important;
}

.endowments-container {
  width: 95%;
  max-width: 1200px !important;
  margin: 0 auto !important;
  padding: 0 10px;
  
  @include respond("md") {
     width: 98%;
     max-width: 100% !important;
     padding: 0 20px;
  }
  
  @include respond("sm") {
     width: 98%;
     padding: 0 5px;
  }
}

.hospitals-placeholder-wrapper {
  width: 100%;
  max-width: 1065px;
  margin: 0 auto;
  
  @include respond("md") {
     width: 98%;
  }
  
  @include respond("sm") {
     width: 98%;
  }
}
</style>
